<script lang="ts">
  import { slide } from "svelte/transition"
  import { Pulse } from "svelte-loading-spinners"
  import Onboarding from "$app/Layouts/Onboarding.svelte"
  import Welcome from "./Welcome.svelte"
  import FoundersMessage from "./FoundersMessage.svelte"
  import YourProfile from "./YourProfile.svelte"
  import PlanSetup from "./PlanSetup.svelte"
  import InviteMembers from "./InviteMembers.svelte"
  import OnePageOverview from "./OnePageOverview.svelte"
  import BrandPurpose from "./BrandPurpose.svelte"
  import Values from "./Values.svelte"
  import BlueSkyVision from "./BlueSkyVision.svelte"
  import Swot from "./Swot.svelte"
  import Departments from "./Departments.svelte"
  import GoalOverview from "./GoalOverview.svelte"
  import LongTermGoal from "./LongTermGoal.svelte"
  import AnnualGoal from "./AnnualGoal.svelte"
  import QuarterlyGoal from "./QuarterlyGoal.svelte"
  import Task from "./Task.svelte"
  import GoalReview from "./GoalReview.svelte"
  import Review from "./Review.svelte"
  import Course from "./Course.svelte"
  import { onboardingStore } from "./onboarding.svelte"
  import { appStore } from "$app/store.svelte"

  type TimeZoneType = { name: string }

  interface Props {
    plan: PlanType
    user: UserType
    subscription: SubscriptionType
    onboarding_steps: string[]
    departments: DepartmentType[]
    root_goal_id: any
    market_segments: MarketSegmentType[]
    time_zones: TimeZoneType[]
    course: any
    course_progress: any
    stripe_publish_key: string
    stripe_product: any
    end_of_year: string
    current_step: string
  }

  let props = $props()

  let {
    plan,
    user,
    subscription,
    onboarding_steps,
    departments,
    root_goal_id,
    market_segments,
    time_zones,
    course = null,
    course_progress,
    stripe_publish_key = null,
    stripe_product = null,
    end_of_year,
    current_step = null
  }: Props = props

  appStore.plan = plan
  appStore.current_user = user
  appStore.departments = [...departments]
  appStore.subscription = subscription
  appStore.end_of_year = end_of_year
  appStore.course = course
  onboardingStore.onboarding_steps = onboarding_steps

  if (current_step) {
    onboardingStore.current_onboarding_step = current_step
  } else {
    onboardingStore.current_onboarding_step =
      onboardingStore.completed_onboarding_step
  }
</script>

<Onboarding current_user={user}>
  {#key onboardingStore.current_onboarding_step}
    {#if onboardingStore.current_onboarding_step === "welcome"}
      <div transition:slide class="z-0">
        <Welcome {market_segments} />
      </div>
    {:else if onboardingStore.current_onboarding_step === "founders_message"}
      <div transition:slide class="z-0">
        <FoundersMessage />
      </div>
    {:else if onboardingStore.current_onboarding_step === "your_profile"}
      <div transition:slide class="z-0">
        <YourProfile />
      </div>
    {:else if onboardingStore.current_onboarding_step === "plan_setup"}
      <div transition:slide class="z-0">
        <PlanSetup {time_zones} />
      </div>
    {:else if onboardingStore.current_onboarding_step === "departments"}
      <div transition:slide>
        <Departments />
      </div>
    {:else if onboardingStore.current_onboarding_step === "invite_members"}
      <div transition:slide class="z-0">
        <InviteMembers />
      </div>
    {:else if onboardingStore.current_onboarding_step === "overview"}
      <div transition:slide class="z-0">
        <OnePageOverview />
      </div>
    {:else if onboardingStore.current_onboarding_step === "brand_purpose" || onboardingStore.current_onboarding_step === "one_page_view"}
      <div transition:slide class="z-0">
        <BrandPurpose />
      </div>
    {:else if onboardingStore.current_onboarding_step === "values"}
      <div transition:slide class="z-0">
        <Values />
      </div>
    {:else if onboardingStore.current_onboarding_step === "blue_sky_vision"}
      <div transition:slide>
        <BlueSkyVision />
      </div>
    {:else if ["swots", "strengths", "weaknesses", "opportunities", "threats"].includes(onboardingStore.current_onboarding_step)}
      <div transition:slide>
        <Swot />
      </div>
    {:else if onboardingStore.current_onboarding_step === "goal_overview"}
      <div transition:slide>
        <GoalOverview />
      </div>
    {:else if onboardingStore.current_onboarding_step === "long_term_goal"}
      <div transition:slide>
        <LongTermGoal {root_goal_id} />
      </div>
    {:else if onboardingStore.current_onboarding_step === "annual_goal"}
      <div transition:slide>
        <AnnualGoal />
      </div>
    {:else if onboardingStore.current_onboarding_step === "quarterly_goal"}
      <div transition:slide>
        <QuarterlyGoal />
      </div>
    {:else if onboardingStore.current_onboarding_step === "task"}
      <div transition:slide>
        <Task />
      </div>
    {:else if onboardingStore.current_onboarding_step === "goal_review"}
      <div transition:slide class="z-0">
        <GoalReview />
      </div>
    {:else if onboardingStore.current_onboarding_step === "review"}
      <div transition:slide>
        <Review />
      </div>
    {:else}
      <div class="mx-auto px-6 pt-4 w-full bg-lwp-pale-grey h-screen">
        <div class="py-12 flex justify-center w-full">
          <Pulse size="300" color="#cdcdcd" unit="px" duration="1s" />
        </div>
      </div>
    {/if}
  {/key}

  {#if !["welcome", "founders_message", "your_profile", "plan_setup", "departments"].includes(onboardingStore.current_onboarding_step)}
    <Course
      {course_progress}
      show={onboardingStore.current_onboarding_step === "overview"}
      {stripe_publish_key}
      {stripe_product}
    />
  {/if}
</Onboarding>
